import React from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../utils/api'
import {useAuth} from "../lib/auth";

export default function SuccessView(){

    const {saveAuth} = useAuth()
    const history = useHistory()

    // Pop up Error Message
    const unSuccessfullyLogin = (error) => {
        window.alert(error);
    }

    // Store Access Token , Refresh Token and username, then go to main page
    const successfullyLogin = (data) => {
        saveAuth(data.access, data.refresh, data.username)
        history.push("/")
    }

    // Handler for Backend Verify API URL
    const eventTrigger = (data) =>{
        if(data){
            successfullyLogin(data);
        } else {
            unSuccessfullyLogin(data);
        }
    }

    const autoWebSumbit = () => {

        // Get Existing Query String
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        // Get token from CCeP Portal
        const access_token = urlParams.get("token");
        console.log("access_token: " + access_token);

        if(!access_token) {
            window.alert("System has issues, please find someone to fix them");
            return;
        }

        // Get refresh token from CCeP Portal when user clicked remember me
        const refresh_token = urlParams.get("refreshToken");
        console.log("refresh_token: " + refresh_token);

        // Create body with access token
        const body = {
            access: access_token
        };

        // Add Optional Items: refresh token to the body
        if(refresh_token) {
            body['refresh'] = refresh_token;
        }

        return body;
    }

    useEffect(async() => {
        // Call Verify API to validate CCeP Token
        const { data }  = await axios.get(API.VERIFY_URL, {params:autoWebSumbit()});
        eventTrigger(data);
    }, []);

    return (
        <div></div>
    )
}